<p-toast (click)="onToastClick()" />
<div class="confirm-dilouge">
  <p-confirmDialog></p-confirmDialog>
  <p-confirmDialog key="update" styleClass="system-confirm-dialog update-dialog"></p-confirmDialog>
  <p-confirmDialog key="notifications" styleClass="system-confirm-dialog notification-dialog"></p-confirmDialog>
</div>
<ngx-ui-loader
  [bgsOpacity]="1"
  fgsType="circle"
  fgsColor="#014E45"
  pbColor="#014E45"
  [fgsSize]="50"
  [pbThickness]="1"
/>
<router-outlet />
